import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, KeepAlive as _KeepAlive, vShow as _vShow, unref as _unref, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "quest-panel",
  "aria-label": "任务层级编辑器"
}
const _hoisted_2 = { class: "quest-toolbar" }
const _hoisted_3 = { class: "quest-counts" }
const _hoisted_4 = { class: "toolbar-actions" }
const _hoisted_5 = {
  class: "quest-view-switch",
  role: "group",
  "aria-label": "任务编辑视图"
}
const _hoisted_6 = ["aria-pressed"]
const _hoisted_7 = ["aria-pressed"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled", "title"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "quest-columns" }
const _hoisted_12 = ["inert"]
const _hoisted_13 = { class: "browser-heading" }
const _hoisted_14 = { class: "tree-search" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "tree-tools" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "tree-empty"
}
const _hoisted_21 = {
  key: 0,
  class: "sub-pagination"
}
const _hoisted_22 = ["disabled", "aria-label", "onClick"]
const _hoisted_23 = ["disabled", "aria-label", "onClick"]
const _hoisted_24 = ["aria-label", "aria-expanded", "disabled", "onClick"]
const _hoisted_25 = {
  key: 1,
  class: "sub-dot"
}
const _hoisted_26 = ["title", "aria-current", "aria-expanded", "onClick"]
const _hoisted_27 = { class: "tree-kind" }
const _hoisted_28 = { class: "tree-title" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "tree-count"
}
const _hoisted_31 = ["disabled", "aria-label", "title", "onClick"]
const _hoisted_32 = {
  key: 1,
  class: "tree-empty"
}
const _hoisted_33 = {
  key: 0,
  class: "tree-pagination"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  class: "quest-breadcrumb",
  "aria-label": "任务路径"
}
const _hoisted_37 = { class: "inspector-header" }
const _hoisted_38 = { class: "kind-badge" }
const _hoisted_39 = { class: "identity-strip" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 0,
  class: "inspector-tabs",
  "aria-label": "子任务属性分组"
}
const _hoisted_43 = ["aria-pressed", "onClick"]
const _hoisted_44 = { class: "form-card title-card" }
const _hoisted_45 = { class: "quest-field" }
const _hoisted_46 = ["aria-label"]
const _hoisted_47 = {
  key: 1,
  class: "form-description"
}
const _hoisted_48 = { class: "quest-field" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "quest-field" }
const _hoisted_51 = ["value"]
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 0,
  role: "alert"
}
const _hoisted_54 = {
  class: "form-card",
  "aria-label": "基本信息"
}
const _hoisted_55 = { class: "quest-field" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "quest-field" }
const _hoisted_58 = { class: "hidden-field" }
const _hoisted_59 = {
  class: "form-card location-card",
  "aria-label": "区域与调查"
}
const _hoisted_60 = { class: "quest-field" }
const _hoisted_61 = { class: "quest-field" }
const _hoisted_62 = { class: "hidden-field" }
const _hoisted_63 = { class: "hidden-field" }
const _hoisted_64 = {
  key: 0,
  class: "inspector-info"
}
const _hoisted_65 = { class: "position-editor" }
const _hoisted_66 = { class: "quest-field" }
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "flow-section" }
const _hoisted_69 = {
  class: "next-quests",
  "aria-label": "后续任务"
}
const _hoisted_70 = {
  key: 0,
  class: "flow-empty"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "next-quest-order" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = ["title"]
const _hoisted_75 = ["disabled", "aria-label", "onClick"]
const _hoisted_76 = ["disabled", "aria-label", "onClick"]
const _hoisted_77 = ["aria-label", "onClick"]
const _hoisted_78 = { class: "next-quest-add" }
const _hoisted_79 = {
  class: "form-card",
  "aria-label": "完成与回溯"
}
const _hoisted_80 = { class: "quest-field" }
const _hoisted_81 = {
  key: 1,
  class: "failure-quest-row"
}
const _hoisted_82 = { class: "failure-quest-name" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 2 }
const _hoisted_85 = { key: 3 }
const _hoisted_86 = { class: "hidden-field" }
const _hoisted_87 = { class: "quest-field" }
const _hoisted_88 = ["value"]
const _hoisted_89 = {
  key: 4,
  class: "children-card"
}
const _hoisted_90 = ["disabled"]
const _hoisted_91 = {
  key: 0,
  class: "form-description"
}
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "child-symbol" }
const _hoisted_94 = {
  key: 1,
  class: "tree-pagination"
}
const _hoisted_95 = ["disabled"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = {
  key: 1,
  class: "inspector-empty"
}
const _hoisted_98 = ["disabled"]
const _hoisted_99 = ["disabled"]

import StudioSelectField from "../StudioSelectField.vue";
import { computed, nextTick, ref, watch } from "vue";
import StudioSidebarContent from "../StudioSidebarContent.vue";
import { toast } from "vue-sonner";
import { useStylePresets } from "../EntityPresetEditor/stylePresets";
import type { TreeSelectOption } from "naive-ui";
import QuestReferenceSelect from "./QuestReferenceSelect.vue";
import QuestMainAreaSelect from "./QuestMainAreaSelect.vue";
import QuestFlowGraph from "./QuestFlowGraph.vue";
import ClipPropertyEditor from "../DialogueEditor/components/clip-editors/ClipPropertyEditor.vue";
import type { ClipPropertyDefinition } from "../DialogueEditor/types/DialogueNode";
import { createQuestChapter, createQuestMain, createQuestSub, removeQuestSubQuests } from "./questProject";
import type { QuestMain, QuestProject, QuestSelection, QuestSub } from "./types";

const SUB_PAGE_SIZE = 50;
const TREE_PAGE_SIZE = 200;
type TreeRow = {
  key: string;
  kind: "unassigned" | "chapter" | "main" | "sub" | "pagination";
  id: number;
  label: string;
  depth: number;
  count?: number;
  page?: number;
  pageCount?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestPanel',
  props: {
    project: {},
    sidebarDisabled: { type: Boolean }
  },
  setup(__props: any) {

const { options: questStyleOptions, error: questStyleError, retry: retryQuestStyles } = useStylePresets("questStyles");
const props = __props;
const selection = ref<QuestSelection | null>(null);
const editorView = ref<"properties" | "flow">("properties");
const search = ref("");
const inspectorSection = ref("basic");
const inspectorSections = [
  { key: "basic", label: "基本信息", hint: "标题、描述与归属" },
  { key: "location", label: "区域与调查", hint: "一级区域、调查点与范围" },
  { key: "flow", label: "任务流转", hint: "后续任务与完成条件" },
];
const treeScroll = ref<HTMLElement>();
const inspector = ref<HTMLElement>();
const childPage = ref(0);
const expanded = ref(new Set<string>(["unassigned"]));
const subPages = ref<Record<number, number>>({});
const treePage = ref(0);
const pointProperty: ClipPropertyDefinition = {
  key: "investigationPoint", label: "调查点", type: "vector3", defaultValue: "0,0,0",
  description: "调查点的三维坐标。",
};

const chaptersById = computed(() => new Map(props.project.chapters.map((item) => [item.id, item])));
const mainsById = computed(() => new Map(props.project.mainQuests.map((item) => [item.id, item])));
const subsById = computed(() => new Map(props.project.subQuests.map((item) => [item.id, item])));
const subGroups = computed(() => {
  const groups = new Map<number, QuestSub[]>();
  for (const sub of props.project.subQuests) {
    const group = groups.get(sub.mainQuestId) ?? [];
    group.push(sub);
    groups.set(sub.mainQuestId, group);
  }
  return groups;
});
const referenceOptions = computed<TreeSelectOption[]>(() => {
  const roots: TreeSelectOption[] = props.project.chapters.map(chapter => ({
    key: `chapter:${chapter.id}`, label: `章节 · ${chapter.title || '未命名章节'} #${chapter.id}`, children: [],
  }));
  const chapterOptions = new Map(roots.map(option => [option.key, option]));
  const unassigned: TreeSelectOption = { key: "unassigned", label: "直属主任务", children: [] };
  for (const main of props.project.mainQuests) {
    const chapter = main.chapterId === null ? undefined : chaptersById.value.get(main.chapterId);
    const path = `${chapter?.title ?? '直属主任务'} / ${main.title}`;
    const option: TreeSelectOption = {
      key: `main:${main.id}`, label: `主任务 · ${main.title || '未命名主任务'} #${main.id}`,
      children: (subGroups.value.get(main.id) ?? []).map(sub => ({
        key: sub.id, label: `${sub.title || '未命名子任务'} #${sub.id}`,
        searchText: `${path} / ${sub.title} ${sub.id}`,
      })),
    };
    const parent = chapterOptions.get(`chapter:${main.chapterId}`) ?? unassigned;
    parent.children!.push(option);
  }
  if (unassigned.children!.length) roots.push(unassigned);
  return roots;
});

function chooseNextQuest(value: number | null, index?: number) {
  const sub = selectedSub.value;
  if (!sub || (value !== null && !subsById.value.has(value))) return;
  if (index !== undefined && (index < 0 || index >= sub.nextQuestIds.length)) return;
  if (index !== undefined && sub.nextQuestIds[index] === value) return;
  if (value !== null && sub.nextQuestIds.some((id, position) => id === value && position !== index)) {
    toast.warning("该任务已在后续任务中，不能重复添加");
    return;
  }
  if (index !== undefined) {
    sub.nextQuestIds[index] = value;
  } else if (value !== null && sub.nextQuestIds.length < 100) sub.nextQuestIds.push(value);
}

function chooseFailureQuest(value: number | null) {
  const sub = selectedSub.value;
  if (!sub || sub.failureQuestId !== -1 || value === null || !subsById.value.has(value)) return;
  sub.failureQuestId = value;
}
function removeFailureQuest() {
  if (selectedSub.value) selectedSub.value.failureQuestId = -1;
}

const selectedChapter = computed(() => selection.value?.kind === "chapter"
  ? chaptersById.value.get(selection.value.id) : undefined);
const selectedMain = computed(() => selection.value?.kind === "main"
  ? mainsById.value.get(selection.value.id) : undefined);
const selectedSub = computed(() => selection.value?.kind === "sub"
  ? subsById.value.get(selection.value.id) : undefined);
const selectedItem = computed(() => selectedChapter.value ?? selectedMain.value ?? selectedSub.value);
const selectedParentMain = computed(() => selectedMain.value
  ?? (selectedSub.value ? mainsById.value.get(selectedSub.value.mainQuestId) : undefined));
const selectedKindLabel = computed(() => ({ chapter: "章节", main: "主任务", sub: "子任务" })[selection.value?.kind ?? "chapter"]);
const activeChapterId = computed(() => selectedChapter.value?.id ?? selectedParentMain.value?.chapterId ?? null);
const parentChapter = computed(() => activeChapterId.value === null ? undefined : chaptersById.value.get(activeChapterId.value));
const childItems = computed(() => selectedChapter.value
  ? props.project.mainQuests.filter(main => main.chapterId === selectedChapter.value?.id)
  : selectedMain.value ? subGroups.value.get(selectedMain.value.id) ?? [] : []);
const childPageCount = computed(() => Math.max(1, Math.ceil(childItems.value.length / SUB_PAGE_SIZE)));
const visibleChildren = computed(() => childItems.value.slice(childPage.value * SUB_PAGE_SIZE, (childPage.value + 1) * SUB_PAGE_SIZE));

function isOpen(key: string) {
  return Boolean(search.value.trim()) || expanded.value.has(key);
}

function matches(item: { id: number; title: string; description?: string }, query: string) {
  return `${item.id} ${item.title} ${item.description ?? ""}`.toLocaleLowerCase().includes(query);
}

const treeRows = computed<TreeRow[]>(() => {
  const rows: TreeRow[] = [];
  const query = search.value.trim().toLocaleLowerCase();
  const filteredSubs = new Map<number, QuestSub[]>();
  const visibleMains = new Set<number>();
  const mainGroups = new Map<number | null, QuestMain[]>();
  for (const main of props.project.mainQuests) {
    const chapter = main.chapterId === null ? undefined : chaptersById.value.get(main.chapterId);
    const includeAll = !query || matches(main, query) || (chapter && matches(chapter, query));
    const children = subGroups.value.get(main.id) ?? [];
    const matchingChildren = includeAll ? children : children.filter((sub) => matches(sub, query));
    filteredSubs.set(main.id, matchingChildren);
    if (includeAll || matchingChildren.length) visibleMains.add(main.id);
    const chapterKey = chapter?.id ?? null;
    const siblings = mainGroups.get(chapterKey) ?? [];
    siblings.push(main);
    mainGroups.set(chapterKey, siblings);
  }

  function addMains(chapterId: number | null) {
    for (const main of mainGroups.get(chapterId) ?? []) {
      if (!visibleMains.has(main.id)) continue;
      const key = `main:${main.id}`;
      rows.push({ key, kind: "main", id: main.id, label: main.title || "未命名主任务", depth: 1,
        count: subGroups.value.get(main.id)?.length ?? 0 });
      if (!isOpen(key)) continue;
      const children = filteredSubs.get(main.id) ?? [];
      const pageCount = Math.max(1, Math.ceil(children.length / SUB_PAGE_SIZE));
      const page = Math.min(subPages.value[main.id] ?? 0, pageCount - 1);
      for (const sub of children.slice(page * SUB_PAGE_SIZE, (page + 1) * SUB_PAGE_SIZE)) {
        rows.push({ key: `sub:${sub.id}`, kind: "sub", id: sub.id,
          label: sub.title || "未命名子任务", depth: 2 });
      }
      if (pageCount > 1) rows.push({ key: `pages:${main.id}`, kind: "pagination", id: main.id,
        label: main.title, depth: 2, page, pageCount, count: children.length });
    }
  }

  for (const chapter of props.project.chapters) {
    const mains = mainGroups.get(chapter.id) ?? [];
    if (query && !matches(chapter, query) && !mains.some((main) => visibleMains.has(main.id))) continue;
    const key = `chapter:${chapter.id}`;
    rows.push({ key, kind: "chapter", id: chapter.id, label: chapter.title || "未命名章节", depth: 0, count: mains.length });
    if (isOpen(key)) addMains(chapter.id);
  }
  const unassigned = mainGroups.get(null) ?? [];
  if (!query || unassigned.some((main) => visibleMains.has(main.id))) {
    rows.push({ key: "unassigned", kind: "unassigned", id: -1, label: "直属主任务", depth: 0, count: unassigned.length });
    if (isOpen("unassigned")) addMains(null);
  }
  return rows;
});
const treePageCount = computed(() => Math.max(1, Math.ceil(treeRows.value.length / TREE_PAGE_SIZE)));
const visibleRows = computed(() => treeRows.value.slice(treePage.value * TREE_PAGE_SIZE, (treePage.value + 1) * TREE_PAGE_SIZE));

watch(treePageCount, (count) => { treePage.value = Math.min(treePage.value, count - 1); });
watch(search, () => { treePage.value = 0; subPages.value = {}; });
watch(childPageCount, count => { childPage.value = Math.min(childPage.value, count - 1); });
watch(() => selection.value ? `${selection.value.kind}:${selection.value.id}` : "", () => {
  childPage.value = 0;
  inspector.value?.scrollTo({ top: 0 });
});
watch(() => props.project, () => {
  // Undo replaces the document but keeps selection/search on surviving tasks.
  if (selection.value && !selectedItem.value) selection.value = null;
});

function toggle(key: string) {
  if (search.value.trim()) return;
  const updated = new Set(expanded.value);
  if (updated.has(key)) updated.delete(key);
  else updated.add(key);
  expanded.value = updated;
}

function selectRow(row: TreeRow) {
  if (row.kind === "unassigned") {
    selection.value = null;
    toggle(row.key);
  } else if (row.kind !== "pagination") {
    selection.value = { kind: row.kind, id: row.id };
    if (row.kind === "chapter" || row.kind === "main") toggle(row.key);
  }
}

async function reveal(target: QuestSelection) {
  search.value = "";
  selection.value = target;
  // Wait for the search reset before choosing a child page; search clears pagination.
  await nextTick();
  const open = new Set(expanded.value);
  const main = target.kind === "main" ? mainsById.value.get(target.id)
    : target.kind === "sub" ? mainsById.value.get(subsById.value.get(target.id)?.mainQuestId ?? -1) : undefined;
  if (target.kind === "chapter") open.add(`chapter:${target.id}`);
  if (main) {
    open.add(main.chapterId === null ? "unassigned" : `chapter:${main.chapterId}`);
    open.add(`main:${main.id}`);
    if (target.kind === "sub") {
      const index = (subGroups.value.get(main.id) ?? []).findIndex((sub) => sub.id === target.id);
      subPages.value = { ...subPages.value, [main.id]: Math.max(0, Math.floor(index / SUB_PAGE_SIZE)) };
    }
  }
  expanded.value = open;
  const index = treeRows.value.findIndex((row) => row.key === `${target.kind}:${target.id}`);
  treePage.value = Math.max(0, Math.floor(index / TREE_PAGE_SIZE));
}

async function locateSelection() {
  if (!selection.value) return;
  await reveal(selection.value);
  await nextTick();
  treeScroll.value?.querySelector(".tree-row.selected")?.scrollIntoView({ block: "nearest" });
}

function expandAll() {
  expanded.value = new Set(["unassigned", ...props.project.chapters.map(item => `chapter:${item.id}`),
    ...props.project.mainQuests.map(item => `main:${item.id}`)]);
}

function reportError(error: unknown) {
  toast.error(error instanceof Error ? error.message : String(error));
}

function addChapter() {
  try { void reveal({ kind: "chapter", id: createQuestChapter(props.project).id }); }
  catch (error) { reportError(error); }
}

function addMain(chapterId: number | null = activeChapterId.value) {
  try { void reveal({ kind: "main", id: createQuestMain(props.project, chapterId).id }); }
  catch (error) { reportError(error); }
}

function addSub(mainId = selectedParentMain.value?.id) {
  if (mainId === undefined) { toast.warning("请先选择一个主任务，再添加子任务"); return; }
  try { void reveal({ kind: "sub", id: createQuestSub(props.project, mainId).id }); }
  catch (error) { reportError(error); }
}

function changeChapter(event: Event) {
  if (!selectedMain.value) return;
  const raw = (event.target as HTMLSelectElement).value;
  const chapterId = raw === "" ? null : Number(raw);
  if (chapterId !== null && !chaptersById.value.has(chapterId)) return;
  selectedMain.value.chapterId = chapterId;
  void reveal({ kind: "main", id: selectedMain.value.id });
}

function changeMain(event: Event) {
  if (!selectedSub.value) return;
  const mainId = Number((event.target as HTMLSelectElement).value);
  if (!mainsById.value.has(mainId)) return;
  selectedSub.value.mainQuestId = mainId;
  void reveal({ kind: "sub", id: selectedSub.value.id });
}

function updatePoint(value: unknown) {
  if (selectedSub.value && typeof value === "string") {
    selectedSub.value.investigationPoint = value;
  }
}

function updateRange(event: Event) {
  const input = event.target as HTMLInputElement;
  if (selectedSub.value && Number.isFinite(input.valueAsNumber)) {
    selectedSub.value.investigationRange = input.valueAsNumber;
  }
}

function updateSubInteger(key: "failureQuestId" | "questProgress" | "belondPrimaryId", event: Event, commit = false) {
  const sub = selectedSub.value;
  if (!sub) return;
  const input = event.target as HTMLInputElement;
  if (key === "failureQuestId" && input.value.trim() === "" && !input.validity?.badInput) {
    sub.failureQuestId = null;
    return;
  }
  const value = input.valueAsNumber;
  if (!Number.isInteger(value) || value < -2147483648 || value > 2147483647) {
    if (commit) {
      toast.warning(`${key === "failureQuestId" ? "失败回溯任务 ID" : key === "belondPrimaryId" ? "所属一级区域 ID" : "任务进度"}必须是 Int32 整数`);
      input.value = String(sub[key] ?? "");
    }
    return;
  }
  sub[key] = value;
}

function moveNextQuest(index: number, offset: number) {
  const ids = selectedSub.value?.nextQuestIds;
  const destination = index + offset;
  if (!ids || index < 0 || index >= ids.length || destination < 0 || destination >= ids.length) return;
  [ids[index], ids[destination]] = [ids[destination], ids[index]];
}

function removeNextQuest(index: number) {
  const ids = selectedSub.value?.nextQuestIds;
  if (ids && index >= 0 && index < ids.length) ids.splice(index, 1);
}

function removeSelected() {
  const target = selection.value;
  const item = selectedItem.value;
  if (!target || !item) return;
  let clearedReferenceCount = 0;
  if (target.kind === "chapter") {
    const count = props.project.mainQuests.filter((main) => main.chapterId === target.id).length;
    if (!confirm(`删除章节「${item.title}」？\n其下 ${count} 个主任务将移到“直属主任务”，主任务和子任务不会删除。`)) return;
    for (const main of props.project.mainQuests) if (main.chapterId === target.id) main.chapterId = null;
    props.project.chapters = props.project.chapters.filter((chapter) => chapter.id !== target.id);
    expanded.value = new Set([...expanded.value, "unassigned"]);
    selection.value = null;
  } else if (target.kind === "main") {
    const count = subGroups.value.get(target.id)?.length ?? 0;
    if (!confirm(`删除主任务「${item.title}」及其 ${count} 个子任务？\n此操作会同时移除这些任务的数据，其他子任务指向它们的后续任务和失败回溯引用将置空，后续任务列表保留位置。`)) return;
    const removedIds = new Set(props.project.subQuests.filter((sub) => sub.mainQuestId === target.id).map((sub) => sub.id));
    clearedReferenceCount = removeQuestSubQuests(props.project, removedIds).clearedReferenceCount;
    props.project.mainQuests = props.project.mainQuests.filter((main) => main.id !== target.id);
    selection.value = null;
  } else {
    if (!confirm(`删除子任务「${item.title}」（ID ${target.id}）？\n其他子任务指向它的后续任务和失败回溯引用将置空，后续任务列表保留位置。`)) return;
    const parentId = selectedSub.value?.mainQuestId;
    clearedReferenceCount = removeQuestSubQuests(props.project, new Set([target.id])).clearedReferenceCount;
    selection.value = parentId === undefined ? null : { kind: "main", id: parentId };
  }
  toast.success(`已删除${({ chapter: "章节", main: "主任务", sub: "子任务" })[target.kind]}${clearedReferenceCount ? `，已将 ${clearedReferenceCount} 项任务引用置空` : ""}`);
}

function changeSubPage(row: TreeRow, offset: number) {
  const page = Math.min((row.pageCount ?? 1) - 1, Math.max(0, (row.page ?? 0) + offset));
  subPages.value = { ...subPages.value, [row.id]: page };
}

function parentLabel(main: QuestMain) {
  const chapter = main.chapterId === null ? undefined : chaptersById.value.get(main.chapterId);
  return `${chapter?.title || "直属主任务"} / ${main.title || "未命名主任务"} #${main.id}`;
}

function editFlowTask(id: number) {
  editorView.value = "properties";
  inspectorSection.value = "flow";
  void reveal({ kind: "sub", id });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[29] || (_cache[29] = _createElementVNode("strong", null, "任务编排", -1)),
        _createElementVNode("span", _hoisted_3, "章节 " + _toDisplayString(__props.project.chapters.length) + "/100 · 主任务 " + _toDisplayString(__props.project.mainQuests.length) + "/100 · 子任务 " + _toDisplayString(__props.project.subQuests.length) + "/10000", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            "aria-pressed": editorView.value === 'properties',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (editorView.value = 'properties'))
          }, "任务属性", 8, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            "aria-pressed": editorView.value === 'flow',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (editorView.value = 'flow'))
          }, "任务衔接图", 8, _hoisted_7)
        ]),
        _createElementVNode("button", {
          type: "button",
          disabled: __props.project.chapters.length >= 100,
          onClick: addChapter
        }, "＋ 章节", 8, _hoisted_8),
        _createElementVNode("button", {
          type: "button",
          disabled: __props.project.mainQuests.length >= 100,
          title: activeChapterId.value === null ? '创建直属主任务' : '在当前章节创建主任务',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addMain()))
        }, "＋ 主任务", 8, _hoisted_9),
        _createElementVNode("button", {
          type: "button",
          class: "primary",
          disabled: !selectedParentMain.value || __props.project.subQuests.length >= 10000,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addSub()))
        }, "＋ 子任务", 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(StudioSidebarContent, null, {
        default: _withCtx(() => [
          _createElementVNode("aside", {
            class: "quest-browser",
            "aria-label": "任务层级",
            inert: __props.sidebarDisabled
          }, [
            _createElementVNode("div", _hoisted_13, [
              _cache[30] || (_cache[30] = _createElementVNode("strong", null, "任务目录", -1)),
              _createElementVNode("span", null, _toDisplayString(__props.project.mainQuests.length + __props.project.subQuests.length) + " 项任务", 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                type: "search",
                "aria-label": "搜索任务",
                placeholder: "搜索标题、描述或 ID"
              }, null, 512), [
                [_vModelText, search.value]
              ]),
              (search.value.trim())
                ? (_openBlock(), _createElementBlock("small", _hoisted_15, "搜索结果会展开匹配任务的父级"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                disabled: Boolean(search.value.trim()),
                onClick: expandAll
              }, "全部展开", 8, _hoisted_17),
              _createElementVNode("button", {
                type: "button",
                disabled: Boolean(search.value.trim()),
                onClick: _cache[5] || (_cache[5] = ($event: any) => {expanded.value = new Set(); treePage.value = 0})
              }, "收起", 8, _hoisted_18),
              _createElementVNode("button", {
                type: "button",
                disabled: !selection.value,
                onClick: locateSelection
              }, "定位当前", 8, _hoisted_19)
            ]),
            _createElementVNode("div", {
              ref_key: "treeScroll",
              ref: treeScroll,
              class: "tree-scroll"
            }, [
              (!visibleRows.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, "没有匹配的章节或任务"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRows.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.key,
                  class: _normalizeClass(["tree-row", [row.kind, { selected: selection.value?.kind === row.kind && selection.value?.id === row.id }]]),
                  style: _normalizeStyle({ '--tree-depth': row.depth })
                }, [
                  (row.kind === 'pagination')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: row.page === 0,
                          "aria-label": `${row.label} 上一页子任务`,
                          onClick: ($event: any) => (changeSubPage(row, -1))
                        }, "‹", 8, _hoisted_22),
                        _createElementVNode("span", null, _toDisplayString((row.page ?? 0) + 1) + "/" + _toDisplayString(row.pageCount) + " 页 · " + _toDisplayString(row.count) + " 项", 1),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: (row.page ?? 0) + 1 >= (row.pageCount ?? 1),
                          "aria-label": `${row.label} 下一页子任务`,
                          onClick: ($event: any) => (changeSubPage(row, 1))
                        }, "›", 8, _hoisted_23)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (row.kind !== 'sub')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "fold-button",
                              "aria-label": `${isOpen(row.key) ? '折叠' : '展开'}${row.label}`,
                              "aria-expanded": isOpen(row.key),
                              disabled: Boolean(search.value.trim()),
                              onClick: ($event: any) => (toggle(row.key))
                            }, _toDisplayString(isOpen(row.key) ? '▾' : '▸'), 9, _hoisted_24))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, "·")),
                        _createElementVNode("button", {
                          type: "button",
                          class: "tree-item",
                          title: `${row.label}${row.id >= 0 ? ` · ID ${row.id}` : ''}`,
                          "aria-current": selection.value?.kind === row.kind && selection.value?.id === row.id ? 'true' : undefined,
                          "aria-expanded": row.kind !== 'sub' ? isOpen(row.key) : undefined,
                          onClick: ($event: any) => (selectRow(row))
                        }, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(row.kind === 'chapter' ? '章' : row.kind === 'sub' ? '子' : '主'), 1),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(row.label), 1),
                          (row.id >= 0)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_29, "#" + _toDisplayString(row.id), 1))
                            : _createCommentVNode("", true),
                          (row.count !== undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(row.count), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_26),
                        (row.kind !== 'sub')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "tree-add",
                              disabled: row.kind === 'main' ? __props.project.subQuests.length >= 10000 : __props.project.mainQuests.length >= 100,
                              "aria-label": `在${row.label}下添加${row.kind === 'main' ? '子任务' : '主任务'}`,
                              title: row.kind === 'main' ? '添加子任务' : '添加主任务',
                              onClick: ($event: any) => (row.kind === 'main' ? addSub(row.id) : addMain(row.kind === 'chapter' ? row.id : null))
                            }, "＋", 8, _hoisted_31))
                          : _createCommentVNode("", true)
                      ], 64))
                ], 6))
              }), 128)),
              (!__props.project.chapters.length && !__props.project.mainQuests.length && !search.value.trim())
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[31] || (_cache[31] = _createElementVNode("p", null, "先创建章节，或直接创建主任务。", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (addMain(null)))
                    }, "＋ 创建主任务")
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            (treePageCount.value > 1)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: treePage.value === 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (treePage.value--))
                  }, "上一页", 8, _hoisted_34),
                  _createElementVNode("span", null, _toDisplayString(treePage.value + 1) + " / " + _toDisplayString(treePageCount.value), 1),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: treePage.value + 1 >= treePageCount.value,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (treePage.value++))
                  }, "下一页", 8, _hoisted_35)
                ]))
              : _createCommentVNode("", true),
            _cache[32] || (_cache[32] = _createElementVNode("p", { class: "tree-footnote" }, [
              _createTextVNode("点击条目编辑 · 点击 ＋ 添加下级任务"),
              _createElementVNode("br"),
              _createTextVNode("改名或移动归属时，任务 ID 保持不变。")
            ], -1))
          ], 8, _hoisted_12)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (editorView.value === 'flow')
          ? (_openBlock(), _createBlock(QuestFlowGraph, {
              key: 0,
              project: __props.project,
              selection: selection.value,
              onSelect: _cache[9] || (_cache[9] = ($event: any) => (reveal({ kind: 'sub', id: $event }))),
              onEdit: editFlowTask
            }, null, 8, ["project", "selection"]))
          : _createCommentVNode("", true)
      ], 1024)),
      _withDirectives(_createElementVNode("main", {
        ref_key: "inspector",
        ref: inspector,
        class: "quest-inspector",
        "aria-label": "任务属性"
      }, [
        (selectedItem.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("nav", _hoisted_36, [
                _cache[35] || (_cache[35] = _createElementVNode("span", null, "任务编排", -1)),
                (parentChapter.value && !selectedChapter.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (reveal({ kind: 'chapter', id: parentChapter.value.id })))
                      }, _toDisplayString(parentChapter.value.title || '未命名章节'), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (selectedSub.value && selectedParentMain.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (reveal({ kind: 'main', id: selectedParentMain.value.id })))
                      }, _toDisplayString(selectedParentMain.value.title || '未命名主任务'), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[36] || (_cache[36] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
                _createElementVNode("span", null, _toDisplayString(selectedKindLabel.value), 1)
              ]),
              _createElementVNode("header", _hoisted_37, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(selectedKindLabel.value), 1),
                  _createElementVNode("h2", null, _toDisplayString(selectedItem.value.title || `未命名${selectedKindLabel.value}`), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "danger",
                  onClick: removeSelected
                }, "删除" + _toDisplayString(selectedKindLabel.value), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", null, [
                  _cache[37] || (_cache[37] = _createTextVNode("ID ", -1)),
                  _createElementVNode("code", null, _toDisplayString(selectedItem.value.id), 1)
                ]),
                (selectedSub.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                      _cache[38] || (_cache[38] = _createTextVNode("归属主任务 ", -1)),
                      _createElementVNode("code", null, _toDisplayString(selectedParentMain.value?.title || '未命名主任务'), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_41, "只读 · 移动时保持不变"))
              ]),
              (selectedSub.value)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_42, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inspectorSections, (tab) => {
                      return _createElementVNode("button", {
                        key: tab.key,
                        type: "button",
                        class: _normalizeClass({ active: inspectorSection.value === tab.key }),
                        "aria-pressed": inspectorSection.value === tab.key,
                        onClick: ($event: any) => (inspectorSection.value = tab.key)
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(tab.label), 1),
                        _createElementVNode("small", null, _toDisplayString(tab.hint), 1)
                      ], 10, _hoisted_43)
                    }), 64))
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(selectedKindLabel.value) + "标题 ", 1),
                    _cache[39] || (_cache[39] = _createElementVNode("code", null, "title", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedItem.value.title) = $event)),
                    "aria-label": `${selectedKindLabel.value}标题`,
                    placeholder: "填写标题"
                  }, null, 8, _hoisted_46), [
                    [_vModelText, selectedItem.value.title]
                  ])
                ])
              ], 512), [
                [_vShow, !selectedSub.value || inspectorSection.value === 'basic']
              ]),
              (selectedChapter.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, "章节用于组织主任务。删除章节时，下属任务会移到直属主任务。"))
                : (selectedMain.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("label", _hoisted_48, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", null, [
                          _createTextVNode("归属章节 "),
                          _createElementVNode("code", null, "chapter")
                        ], -1)),
                        _createVNode(StudioSelectField, {
                          value: selectedMain.value.chapterId ?? '',
                          "aria-label": "归属章节",
                          onChange: changeChapter
                        }, {
                          default: _withCtx(() => [
                            _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "无章节 · 直属主任务", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.chapters, (chapter) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: chapter.id,
                                value: chapter.id
                              }, _toDisplayString(chapter.title || '未命名章节') + " #" + _toDisplayString(chapter.id), 9, _hoisted_49))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("label", _hoisted_50, [
                        _cache[42] || (_cache[42] = _createElementVNode("span", null, [
                          _createTextVNode("主任务样式 "),
                          _createElementVNode("code", null, "style")
                        ], -1)),
                        _createVNode(StudioSelectField, {
                          modelValue: selectedMain.value.style,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedMain.value.style) = $event)),
                          "aria-label": "选择主任务样式预设"
                        }, {
                          default: _withCtx(() => [
                            (!_unref(questStyleOptions).some(item => item.value === selectedMain.value?.style))
                              ? (_openBlock(), _createElementBlock("option", {
                                  key: 0,
                                  value: selectedMain.value.style
                                }, _toDisplayString(selectedMain.value.style || '未设置') + "（当前值）", 9, _hoisted_51))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questStyleOptions), (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.value,
                                value: item.value
                              }, _toDisplayString(item.label) + "（" + _toDisplayString(item.value) + "）", 9, _hoisted_52))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _cache[43] || (_cache[43] = _createElementVNode("small", null, "从下拉框选择主任务样式。", -1)),
                        (_unref(questStyleError))
                          ? (_openBlock(), _createElementBlock("small", _hoisted_53, [
                              _createTextVNode(_toDisplayString(_unref(questStyleError)) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(retryQuestStyles)().catch(() => undefined)))
                              }, "重试样式预设")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : (selectedSub.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _withDirectives(_createElementVNode("section", _hoisted_54, [
                          _createElementVNode("label", _hoisted_55, [
                            _cache[44] || (_cache[44] = _createElementVNode("span", null, [
                              _createTextVNode("归属主任务 "),
                              _createElementVNode("code", null, "mainQuestId")
                            ], -1)),
                            _createVNode(StudioSelectField, {
                              value: selectedSub.value.mainQuestId,
                              "aria-label": "归属主任务",
                              onChange: changeMain
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.mainQuests, (main) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: main.id,
                                    value: main.id
                                  }, _toDisplayString(parentLabel(main)), 9, _hoisted_56))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _createElementVNode("label", _hoisted_57, [
                            _cache[45] || (_cache[45] = _createElementVNode("span", null, [
                              _createTextVNode("任务描述 "),
                              _createElementVNode("code", null, "desc")
                            ], -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedSub.value.description) = $event)),
                              "aria-label": "任务描述",
                              rows: "4",
                              placeholder: "填写任务描述"
                            }, null, 512), [
                              [_vModelText, selectedSub.value.description]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_58, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedSub.value.hidden) = $event)),
                              type: "checkbox",
                              role: "switch",
                              "aria-label": "隐藏任务"
                            }, null, 512), [
                              [_vModelCheckbox, selectedSub.value.hidden]
                            ]),
                            _cache[46] || (_cache[46] = _createElementVNode("span", null, "隐藏任务", -1))
                          ])
                        ], 512), [
                          [_vShow, inspectorSection.value === 'basic']
                        ]),
                        _withDirectives(_createElementVNode("section", _hoisted_59, [
                          _cache[53] || (_cache[53] = _createElementVNode("h3", { class: "form-heading" }, "区域与调查", -1)),
                          _cache[54] || (_cache[54] = _createElementVNode("p", { class: "form-description" }, "设置任务所属的一级区域，以及玩家需要调查的位置。", -1)),
                          _createElementVNode("label", _hoisted_60, [
                            _cache[47] || (_cache[47] = _createElementVNode("span", null, [
                              _createTextVNode("单位状态 "),
                              _createElementVNode("code", null, "unitState · ConfigReference")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedSub.value.unitState) = $event)),
                              "aria-label": "单位状态",
                              placeholder: "填写配置引用"
                            }, null, 512), [
                              [_vModelText, selectedSub.value.unitState]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _cache[48] || (_cache[48] = _createElementVNode("span", null, [
                              _createTextVNode("所属一级区域 "),
                              _createElementVNode("code", null, "belondPrimaryId")
                            ], -1)),
                            _createVNode(QuestMainAreaSelect, {
                              modelValue: selectedSub.value.belondPrimaryId,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedSub.value.belondPrimaryId) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("label", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedSub.value.showGuide) = $event)),
                              type: "checkbox",
                              role: "switch",
                              "aria-label": "显示任务地图指引"
                            }, null, 512), [
                              [_vModelCheckbox, selectedSub.value.showGuide]
                            ]),
                            _cache[49] || (_cache[49] = _createElementVNode("span", null, "显示任务地图指引", -1))
                          ]),
                          _createElementVNode("label", _hoisted_63, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((selectedSub.value.showEffect) = $event)),
                              type: "checkbox",
                              role: "switch",
                              "aria-label": "显示任务指引特效"
                            }, null, 512), [
                              [_vModelCheckbox, selectedSub.value.showEffect]
                            ]),
                            _cache[50] || (_cache[50] = _createElementVNode("span", null, "显示任务指引特效", -1))
                          ]),
                          (selectedSub.value.legacyInvestigationPoint)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_64, "已沿用旧调查点的 Vector3 坐标；原配置已保留备份。若原先使用实体、GUID 或偏移，请核对这里的最终坐标。"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(ClipPropertyEditor, {
                              property: pointProperty,
                              "model-value": selectedSub.value.investigationPoint,
                              "onUpdate:modelValue": updatePoint
                            }, null, 8, ["model-value"])
                          ]),
                          _createElementVNode("label", _hoisted_66, [
                            _cache[51] || (_cache[51] = _createElementVNode("span", null, [
                              _createTextVNode("调查范围 "),
                              _createElementVNode("code", null, "investigationRange")
                            ], -1)),
                            _createElementVNode("input", {
                              type: "number",
                              "aria-label": "调查范围",
                              value: selectedSub.value.investigationRange,
                              step: "any",
                              onInput: updateRange
                            }, null, 40, _hoisted_67),
                            _cache[52] || (_cache[52] = _createElementVNode("small", null, "保留结构体默认值 -1；可填写所需范围。", -1))
                          ])
                        ], 512), [
                          [_vShow, inspectorSection.value === 'location']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_68, [
                          _createElementVNode("section", _hoisted_69, [
                            _createElementVNode("header", null, [
                              _cache[55] || (_cache[55] = _createElementVNode("h3", null, [
                                _createTextVNode("后续任务 "),
                                _createElementVNode("code", null, "nextQuestIds · Int32List")
                              ], -1)),
                              _createElementVNode("small", null, _toDisplayString(selectedSub.value.nextQuestIds.length) + "/100", 1)
                            ]),
                            _cache[56] || (_cache[56] = _createElementVNode("p", null, "当前任务结束后，按以下顺序衔接后续任务。", -1)),
                            (!selectedSub.value.nextQuestIds.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, "暂无后续任务，从下方选择任务以建立关联。"))
                              : _createCommentVNode("", true),
                            (selectedSub.value.nextQuestIds.length)
                              ? (_openBlock(), _createElementBlock("ol", _hoisted_71, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSub.value.nextQuestIds, (id, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: index,
                                      class: _normalizeClass({ 'is-empty': id === null })
                                    }, [
                                      _createElementVNode("span", _hoisted_72, _toDisplayString(index + 1), 1),
                                      _createVNode(QuestReferenceSelect, {
                                        options: referenceOptions.value,
                                        "model-value": id,
                                        label: `选择后续任务 ${index + 1}`,
                                        "onUpdate:modelValue": ($event: any) => (chooseNextQuest($event, index))
                                      }, null, 8, ["options", "model-value", "label", "onUpdate:modelValue"]),
                                      (id === null)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_73, "空引用 · 导出为 -1"))
                                        : (_openBlock(), _createElementBlock("small", {
                                            key: 1,
                                            title: subsById.value.get(id)?.title
                                          }, _toDisplayString(subsById.value.has(id) ? (subsById.value.get(id)?.title || '未命名子任务') : '当前文件未找到此 ID'), 9, _hoisted_74)),
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: index === 0,
                                        "aria-label": `上移后续任务 ${index + 1}`,
                                        onClick: ($event: any) => (moveNextQuest(index, -1))
                                      }, "↑", 8, _hoisted_75),
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: index === selectedSub.value.nextQuestIds.length - 1,
                                        "aria-label": `下移后续任务 ${index + 1}`,
                                        onClick: ($event: any) => (moveNextQuest(index, 1))
                                      }, "↓", 8, _hoisted_76),
                                      _createElementVNode("button", {
                                        type: "button",
                                        "aria-label": `移除后续任务 ${index + 1}`,
                                        onClick: ($event: any) => (removeNextQuest(index))
                                      }, "×", 8, _hoisted_77)
                                    ], 2))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_78, [
                              _createVNode(QuestReferenceSelect, {
                                options: referenceOptions.value,
                                "model-value": null,
                                label: "添加后续任务",
                                placeholder: "＋ 选择后续任务，可搜索任务名",
                                disabled: selectedSub.value.nextQuestIds.length >= 100,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (chooseNextQuest($event)))
                              }, null, 8, ["options", "disabled"])
                            ]),
                            _cache[57] || (_cache[57] = _createElementVNode("small", null, "删除任务时，指向它的引用会置空并保留位置；可以重新选择任务或移除此项。导出时会警告空引用及当前文件中不存在的 ID。", -1))
                          ]),
                          _createElementVNode("section", _hoisted_79, [
                            _cache[62] || (_cache[62] = _createElementVNode("h3", { class: "form-heading" }, "完成与回溯", -1)),
                            _createElementVNode("div", _hoisted_80, [
                              _cache[58] || (_cache[58] = _createElementVNode("span", null, [
                                _createTextVNode("失败回溯任务 "),
                                _createElementVNode("code", null, "失败回溯任务 · Int32")
                              ], -1)),
                              (selectedSub.value.failureQuestId === -1)
                                ? (_openBlock(), _createBlock(QuestReferenceSelect, {
                                    key: 0,
                                    options: referenceOptions.value,
                                    "model-value": null,
                                    label: "添加回溯任务",
                                    placeholder: "＋ 添加回溯任务，可搜索任务名",
                                    "onUpdate:modelValue": chooseFailureQuest
                                  }, null, 8, ["options"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, [
                                      (selectedSub.value.failureQuestId === null)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_83, "回溯目标已删除或未指定"))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("strong", null, _toDisplayString(subsById.value.get(selectedSub.value.failureQuestId)?.title || (subsById.value.has(selectedSub.value.failureQuestId) ? '未命名子任务' : '未找到回溯任务')), 1),
                                            _createElementVNode("small", null, "#" + _toDisplayString(selectedSub.value.failureQuestId), 1)
                                          ], 64))
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "danger",
                                      "aria-label": "删除回溯任务关联",
                                      onClick: removeFailureQuest
                                    }, "删除")
                                  ])),
                              (selectedSub.value.failureQuestId === null || (selectedSub.value.failureQuestId !== -1 && !subsById.value.has(selectedSub.value.failureQuestId)))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_84, "此关联未找到有效目标，可删除关联后重新选择。"))
                                : (_openBlock(), _createElementBlock("small", _hoisted_85, "只能添加一个回溯任务；删除关联后可以重新选择。"))
                            ]),
                            _createElementVNode("label", _hoisted_86, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((selectedSub.value.finishMainQuest) = $event)),
                                type: "checkbox",
                                role: "switch",
                                "aria-label": "完成主任务"
                              }, null, 512), [
                                [_vModelCheckbox, selectedSub.value.finishMainQuest]
                              ]),
                              _cache[59] || (_cache[59] = _createElementVNode("span", null, "完成主任务", -1))
                            ]),
                            _createElementVNode("label", _hoisted_87, [
                              _cache[60] || (_cache[60] = _createElementVNode("span", null, [
                                _createTextVNode("任务进度 "),
                                _createElementVNode("code", null, "questProgress · Int32")
                              ], -1)),
                              _createElementVNode("input", {
                                type: "number",
                                "aria-label": "任务进度",
                                value: selectedSub.value.questProgress,
                                step: "1",
                                min: "-2147483648",
                                max: "2147483647",
                                onInput: _cache[23] || (_cache[23] = ($event: any) => (updateSubInteger('questProgress', $event))),
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (updateSubInteger('questProgress', $event, true)))
                              }, null, 40, _hoisted_88),
                              _cache[61] || (_cache[61] = _createElementVNode("small", null, "默认 0，按填写的整数导出。", -1))
                            ])
                          ])
                        ], 512), [
                          [_vShow, inspectorSection.value === 'flow']
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
              (selectedChapter.value || selectedMain.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_89, [
                    _createElementVNode("header", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", null, _toDisplayString(selectedChapter.value ? '章节下的主任务' : '主任务下的子任务'), 1),
                        _createElementVNode("small", null, _toDisplayString(childItems.value.length) + " 项 · 点击直接编辑", 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "primary",
                        disabled: selectedChapter.value ? __props.project.mainQuests.length >= 100 : __props.project.subQuests.length >= 10000,
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (selectedChapter.value ? addMain(selectedChapter.value.id) : addSub(selectedMain.value?.id)))
                      }, "＋ " + _toDisplayString(selectedChapter.value ? '主任务' : '子任务'), 9, _hoisted_90)
                    ]),
                    (!childItems.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_91, "还没有" + _toDisplayString(selectedChapter.value ? '主任务' : '子任务') + "，创建一个开始编排。", 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleChildren.value, (child) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: child.id,
                        type: "button",
                        class: "child-link",
                        onClick: ($event: any) => (reveal({ kind: selectedChapter.value ? 'main' : 'sub', id: child.id }))
                      }, [
                        _createElementVNode("span", _hoisted_93, _toDisplayString(selectedChapter.value ? '主' : '子'), 1),
                        _createElementVNode("span", null, _toDisplayString(child.title || '未命名任务'), 1),
                        _createElementVNode("small", null, "#" + _toDisplayString(child.id), 1),
                        _cache[63] || (_cache[63] = _createElementVNode("span", { "aria-hidden": "true" }, "›", -1))
                      ], 8, _hoisted_92))
                    }), 128)),
                    (childPageCount.value > 1)
                      ? (_openBlock(), _createElementBlock("footer", _hoisted_94, [
                          _createElementVNode("button", {
                            type: "button",
                            disabled: childPage.value === 0,
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (childPage.value--))
                          }, "上一页", 8, _hoisted_95),
                          _createElementVNode("span", null, _toDisplayString(childPage.value + 1) + " / " + _toDisplayString(childPageCount.value), 1),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: childPage.value + 1 >= childPageCount.value,
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (childPage.value++))
                          }, "下一页", 8, _hoisted_96)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_97, [
              _cache[64] || (_cache[64] = _createElementVNode("span", { class: "empty-symbol" }, "☷", -1)),
              _cache[65] || (_cache[65] = _createElementVNode("h2", null, "按层级组织任务", -1)),
              _cache[66] || (_cache[66] = _createElementVNode("p", null, [
                _createTextVNode("章节 → 主任务 → 子任务"),
                _createElementVNode("br"),
                _createTextVNode("也可以跳过章节，直接创建主任务。")
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: __props.project.chapters.length >= 100,
                  onClick: addChapter
                }, "＋ 创建章节", 8, _hoisted_98),
                _createElementVNode("button", {
                  type: "button",
                  class: "primary",
                  disabled: __props.project.mainQuests.length >= 100,
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (addMain(null)))
                }, "＋ 创建主任务", 8, _hoisted_99)
              ]),
              _cache[67] || (_cache[67] = _createElementVNode("small", null, "选择左侧条目编辑属性。任务配置自动保存在当前工作区，结构体导出用于千星变量。", -1))
            ]))
      ], 512), [
        [_vShow, editorView.value === 'properties']
      ])
    ])
  ]))
}
}

})